import { CommonHelper } from 'src/utils/commonHelper';

export const twakPermissionNames = [
  CommonHelper.PermissionList.CHAT_VIEW,
  CommonHelper.PermissionList.CHAT_REPLY,
  CommonHelper.PermissionList.CHAT_ASSIGN,
  CommonHelper.PermissionList.TICKET_MANAGE,
  CommonHelper.PermissionList.FAQ_MANAGE,
  CommonHelper.PermissionList.KB_MANAGE,
  CommonHelper.PermissionList.AI_CHAT_MANAGE,
  CommonHelper.PermissionList.WIDGET_MANAGE,
  CommonHelper.PermissionList.CONTACT_VIEW,
  CommonHelper.PermissionList.ANALYTICS_VIEW,
];

export const twakRolePresets = [
  {
    roleName: 'Support Agent',
    permissions: [
      CommonHelper.PermissionList.CHAT_VIEW,
      CommonHelper.PermissionList.CHAT_REPLY,
      CommonHelper.PermissionList.CHAT_ASSIGN,
      CommonHelper.PermissionList.TICKET_MANAGE,
      CommonHelper.PermissionList.CONTACT_VIEW,
    ],
  },
];

export const isTwakPermission = (permissionName) => twakPermissionNames.includes(permissionName);

export const splitPermissionsByProduct = (permissions) => {
  const twakPermissions = [];
  const legacyPermissions = [];
  permissions.forEach((permission) => {
    if (isTwakPermission(permission.permission_name)) {
      twakPermissions.push(permission);
    } else {
      legacyPermissions.push(permission);
    }
  });
  return { twakPermissions, legacyPermissions };
};

export const getRoleScopeLabel = (role) => {
  if (role?.is_org_role) return 'Org';
  return 'Workspace';
};
